module.exports = "/images/8a5412f3eb2570bab9d22f9c7b2da65b.svg";